import { Component } from '@angular/core';
import { PrismicService } from '../../services/prismic/prismic.service';
import { ActivatedRoute } from '@angular/router';
import {PrismicInfoPage} from "../../../types/app-types";

@Component({
  selector: 'app-info',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss']
})
export class InfoPageComponent {
  public cmsContent: InfoContent;

  constructor(
    private prismic: PrismicService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.paramMap.subscribe(params => {
      const page = params.get('page');
      prismic.getDocumentByUid<PrismicInfoPage>('infopage', page).then(doc => {
        this.cmsContent = this.transform(doc.data);
      });
    });
  }

  private transform(doc: any): InfoContent {
    return <InfoContent>{
      title: this.prismic.convertToText(doc.title),
      subtitle: this.prismic.convertToText(doc.subtitle),
      body: this.prismic.convertToHtml(doc.body)
    };
  }
}

export interface InfoContent {
  title: string,
  subtitle: string
  body: any
}
